
import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule, ActivatedRoute } from "@angular/router";
import { OrderService } from "@services/order/order-service";
import { ErrorTexts, JapaneseLabels } from "@utils/japaneseLabels";



/**
 * Dashboard component.
 * Displays the main dashboard page, handles route labels, error texts, and loading state.
 */
@Component({
  selector: "app-dashboard",
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule],
  templateUrl: "./dashboard.html",
  styleUrl: "./dashboard.scss",
})
export class Dashboard {
  /** Japanese text labels for routes */
  japaneseLabels = JapaneseLabels;
  /** Error text labels */
  errorTexts = ErrorTexts;
  /** Loading state for dashboard data */
  loading: boolean = false;

  /**
   * Constructs the Dashboard component.
   * 
   * @param route ActivatedRoute for accessing route information 
   * @param orderService Service for fetching order-related data
   */
  constructor(
    private route: ActivatedRoute, private orderService: OrderService
  ) { }


  /**
   * Angular lifecycle hook.
   * Fetches the initial customer list on component initialization.
   */
  ngOnInit() {
    this.countList();
  }

  invalidCount: number = 0;
  totalCount: number = 0;
  validCount: number = 0;

  /**
   * Fetch dashboard counts.
   *
   * Retrieves order counts (invalid, total, valid) from the OrderService and
   * updates local component state. While the request is running the loading
   * flag is true; it is cleared on error or completion.
   */
  countList() {
    this.loading = true;
    this.orderService.getOrderRecords().subscribe({
      next: (response) => {

        this.invalidCount = response.invalid_count;
        this.totalCount = response.total_count;
        this.validCount = response.valid_count;
      },
      error: (err) => {
        console.error("Error", err);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    });

  }
}